import React, { useState } from "react";
import { Link } from "react-router-dom";

export const TabNavigation = ({ tabs, activeTab, onTabChange, getTabHref }) => {
  const [isToggled, setIsToggled] = useState(false);

  return (
    <div className="border-b border-gray-200 ">

      {/* Header Section */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between 
                      gap-3 px-4 sm:px-6 py-4">

        {/* Title + Description */}
        <div className="min-w-0">
          <h1 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#424242]">
            Domain Management
          </h1>
          <p className="text-sm text-gray-600 mt-1 max-w-2xl">
            Detailed overview of the selected asset under the chosen product and
            domain hierarchy.
          </p>
        </div>

        {/* Toggle */}
        <label className="flex items-center cursor-pointer select-none">
          <input
            type="checkbox"
            className="sr-only"
            checked={isToggled}
            onChange={() => setIsToggled(!isToggled)}
          />
        </label>
      </div>

      {/* Tabs Section */}
      <div className="px-4 sm:px-6 pb-3">
        <nav className="flex gap-2 overflow-x-auto scrollbar-hide whitespace-nowrap">
          {tabs.map((tab) => {
            const href = getTabHref ? getTabHref(tab.id) : "#";

            const handleClick = (e) => {
              const isModifiedClick =
                e.metaKey ||
                e.ctrlKey ||
                e.shiftKey ||
                e.altKey ||
                e.button !== 0;
              if (isModifiedClick) return;
              if (onTabChange) {
                e.preventDefault();
                onTabChange(tab.id);
              }
            };

            const isActive = activeTab === tab.id;

            return (
              <Link
                key={tab.id}
                to={href}
                onClick={handleClick}
                className={`
                  flex items-center gap-2 shrink-0
                  px-4 py-2 text-sm font-medium
                  border transition-all duration-200 rounded-lg
                  ${
                    isActive
                      ? "bg-[#E6E8FA] text-[#bb1ccc] border-[#0F0791]"
                      : "bg-white text-[#404040] border-[#818181] hover:bg-gray-50"
                  }
                `}
              >
                {/* Icon */}
                {tab.icon && (
                  <span className={isActive ? "text-[#bb1ccc]" : "text-[#404040]"}>
                    {tab.icon}
                  </span>
                )}

                {/* Label */}
                {tab.label}

                {/* Count Badge */}
                {tab.count && (
                  <span className={`px-2 py-0.5 text-xs rounded ${
                    isActive
                      ? "bg-[#bb1ccc] text-white"
                      : "bg-[#DBDBDB] text-[#404040]"
                  }`}>
                    {tab.count}
                  </span>
                )}
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};